const React = require("react");
const upperFirst = require("mn-utils/upperFirst");
const toLower = require("mn-utils/toLower");
const FieldC = require("../../../../dumb/Field/C");
const {DisplayDataMerchant, DisplayAmountMerchant, DisplayDateDetailedMerchant} = require("../../../../dumb/DisplayData");

module.exports = (props) => {
  const data = props.data || {};
  const status = toLower(data.status || '');
  const time = data.created_at || '';

  const list = [
    {
      label: 'IBAN / Account number',
      value: (
        <DisplayDataMerchant>
          {data.iban}
        </DisplayDataMerchant>
      ),
    },
    {
      label: 'Withdraw amount',
      value: (
        <DisplayAmountMerchant
          amount={data.amount}
          symbol={data.fiat_code}
          type="fiat"
        />
      ),
    },
    {
      label: 'Status',
      value: (
        <div
          className={`cFFBF43.pending c2CE889.completed
                c8.canceled cEE4F4F.failed c5B47FF.initiated ` + status}
        >{upperFirst(status)}</div>
      ),
    },
    {
      label: 'Transaction date and time',
      value: (
        <DisplayDateDetailedMerchant date={time} />
      ),
    },
    {
      label: 'Bank',
      value: <DisplayDataMerchant>{data.bank_name}</DisplayDataMerchant>,
    },
    {
      label: 'SWIFT code / BIC',
      value: <DisplayDataMerchant>{data.bank_name}</DisplayDataMerchant>,
    }
  ];

  return (
    <div className="mt45 cfx mh-10 (lt|ph10|w1/3|w1/2@m|w@m2)>1">
      {list.map((el, id) => (
        <FieldC
          key={id}
          label={el.label}
          value={el.value || '-'}
        />
      ))}
    </div>
  )
}
